/**
 * Diagnostics a host never sees (the generator's working notes, its cost). Whoever needs them
 * opens any app page once with `?debug=1`; `?debug=0` turns them off again. Remembered in this
 * browser only.
 */
const KEY = 'str:debug';

export function debugOn(search: string = window.location.search): boolean {
  const asked = new URLSearchParams(search).get('debug');
  try {
    if (asked === '1') localStorage.setItem(KEY, '1');
    if (asked === '0') localStorage.removeItem(KEY);
    return localStorage.getItem(KEY) === '1';
  } catch {
    return asked === '1';
  }
}
